@import "../../../styles/base";
@import "../../../components/design-system/Button/styles/surfaces";

.Alert {
  border-radius: 0.5rem;
  background-color: $ds-violet-100;
  @include violet-surface;
  color: $ds-violet-900;
  padding: 1rem;
  display: flex;
  flex-wrap: nowrap;
  min-width: 14rem;
  width: 100%;
  box-shadow: $card-shadow;
  text-align: left;

  & + .Alert {
    margin-top: 1rem;
  }

  svg {
    width: auto;
    height: auto;
  }

  .Main {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    align-content: space-between;

    &.hasTitle,
    &.hasCustomIcon {
      .Content {
        // If the toast has a title or a custom icon, it cannot also have inline buttons, they always drop to a new line. There might be room for inline icons, but there's no obvious way to align everything.
        flex: 1 0 100%;
      }
    }

    .Content {
      flex: 1 1 auto;
      padding: 0.25rem 0;
    }
  }

  .Icon {
    margin-right: 1rem;
    display: inline-block;
    flex: 0 0 auto;
    padding: 0.25rem;
  }

  .Title,
  .Message {
    display: block;
  }

  .Title {
    font-weight: $ds-font-weight-medium;
  }

  .Actions {
    @include button-group;
    flex: 1 0 auto;
    text-align: right;
  }

  .Close {
    appearance: none;
    cursor: pointer;
    background: none;
    border: none;
    color: inherit;
    outline: 1px solid inherit;
    padding-top: 4px;
    padding-bottom: 4px;
    height: 24px;
    margin-left: 1rem;
    flex: 0 0 2em;
  }
}

// Variant colours:

.danger {
  @include coral-surface;
  background-color: $ds-coral-50;
  color: $ds-coral-900;
}

.success {
  @include jade-surface;
  background-color: $ds-jade-50;
  color: $ds-jade-900;
}

.warning {
  @include mustard-surface;
  background-color: $ds-mustard-50;
  color: $ds-mustard-900;
}

.info {
  @include teal-surface;
  background-color: $ds-teal-50;
  color: $ds-teal-900;
}

.plain {
  @include white-surface;
  background-color: $white;
  color: $ds-violet-900;
}

@media (max-width: 700px) {
  .Alert {
    padding: 0.75rem;

    .Icon {
      margin-right: 0.75rem;
    }
  }
}
